import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaServiceRateKpi } from 'src/app/assabil-sales/models/dtos/geo-area-service-rate-kpi';

@Component({
  selector: 'geo-area-service-rate-kpi',
  templateUrl: './geo-area-service-rate-kpi.component.html',
  styleUrls: ['./geo-area-service-rate-kpi.component.scss']
})
export class GeoAreaServiceRateKpiComponent implements OnInit {


  @Input() geoAreaServiceRateKpi : GeoAreaServiceRateKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;
  @Input() showDayValues  : boolean;
  @Input() showMtdValues  : boolean;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {
  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaServiceRateKpi.expanded = !this.geoAreaServiceRateKpi.expanded;
  }
}